import { api } from "../../api/fetch";
import { TestCase } from '../entity';

export const updateTestSpecification = async (testCase: TestCase) => {
    return  await api.put(`/api/v1/test-suites/${testCase.test_suite_id}/tests/${testCase.id}`, testCase);
}

export default updateTestSpecification;
